import _ from "lodash";

export default {
    state: {
        list: [],
        count: null,
        filters: {
            orderBy: 'data',
            desc: true,
            date: {
                min: null,
                max: null
            },
            devices: []
        }
    },

    mutations: {
        ACCESS_SET_LIST(state, list) {
            state.list = list
        },

        ACCESS_SET_COUNT(state, count) {
            state.count = count
        },

        ACCESS_SET_FILTER(state, {key, value}) {
            state.filters = {
                ...state.filters,
                [key]: value,
            }
        },

        ACCESS_RESET_FILTERS(state){
            state.filters = {
                orderBy: 'data',
                desc: true,
                date: {
                    min: null,
                    max: null
                },
                devices: []
            }
        },

        SET_DEVICES(state, devices) {
            state.devices = devices
        }

    },

    getters: {
       mappedDevicesAccess(state) {
            let devices = [];
            if (state.devices){
                state.devices.forEach(function(item){
                    devices.push(item);
                })
            }

            return _.map(devices, (device) => {
                return {
                    id: device.id,
                    label: device.nome
                }
            })
        }
    }
}
